import { Link } from "react-router-dom";
import { siteStats, testimonials } from "@/mocks/anime";
import SEOHead from "@/components/base/SEOHead";

export default function AboutPage() {
  return (
    <main className="pt-16 min-h-screen bg-background-50">
      <SEOHead
        title="关于我们 | 51动漫官网 | 品牌介绍与联系方式"
        description="了解51动漫官网的品牌故事、用户口碑和联系方式。51动漫官网——免费动漫在线观看与下载平台，涵盖日漫韩漫国漫剧场版，支持下拉式阅读。"
        keywords="51动漫官网,关于51动漫,动漫网站,联系我们,动漫平台"
        canonicalUrl="https://www.51anime.com/about"
      />

      <section className="bg-white py-14 md:py-20">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center bg-primary-100 rounded-2xl">
              <i className="ri-play-circle-fill text-3xl text-primary-500"></i>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-3">关于51动漫官网</h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              51动漫官网是一个致力于为广大动漫爱好者提供优质动漫资源的综合平台。我们提供51动漫在线观看、51动漫下载等服务，涵盖动漫全集资源，支持下拉式阅读模式，让追番体验更加流畅愉快。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {siteStats.map((stat, i) => (
              <div key={i} className="bg-background-50 rounded-2xl p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-background-200 rounded-xl">
                  <i className={`${stat.icon} text-xl text-primary-500`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-foreground-950">{stat.value}</div>
                <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">品牌故事</h2>
            <p className="text-sm text-foreground-600 mt-2">了解51动漫官网背后的初心与愿景</p>
          </div>

          <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-6 md:p-8">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl mb-4">
                <i className="ri-lightbulb-line text-2xl text-primary-500"></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-3">我们的初心</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                51动漫官网诞生于一群资深动漫爱好者对优质动漫内容的热爱与追求。我们发现市面上许多动漫网站要么资源不全，要么广告泛滥、体验极差。于是我们决定自己动手，打造一个干净、高效、资源丰富的动漫平台。从最初的日漫小站，到如今涵盖日漫、韩漫、国漫、剧场版的全方位动漫平台，我们始终不忘「让每个人都能轻松享受动漫」的初心。
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 md:p-8">
              <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mb-4">
                <i className="ri-rocket-line text-2xl text-accent-500"></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-3">我们的使命</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                我们致力于成为国内领先的免费动漫资源平台。通过持续优化技术架构和内容推荐算法，为用户提供更流畅的在线观看体验和更精准的动漫推荐服务。我们的下拉式阅读模式打破了传统翻页的限制，让漫画阅读如短视频般流畅。未来，我们还将引入更多创新功能，让追番成为一种享受。
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-14 md:py-20">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">用户口碑</h2>
            <p className="text-sm text-foreground-600 mt-2">听听动漫爱好者们怎么说</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((t, i) => (
              <div key={i} className="bg-white rounded-2xl p-6">
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <i key={j} className="ri-star-fill text-yellow-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-5">&ldquo;{t.content}&rdquo;</p>
                <div className="flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <span className="text-sm font-semibold text-foreground-800">{t.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="contact" className="py-14 md:py-20">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">联系我们</h2>
            <p className="text-sm text-foreground-600 mt-2">如有任何问题或合作意向，欢迎联系我们</p>
          </div>

          <div className="max-w-2xl mx-auto">
            <div className="bg-white rounded-2xl p-6 md:p-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-background-100 rounded-xl">
                    <i className="ri-mail-line text-xl text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">客服邮箱</p>
                    <p className="text-sm font-medium text-foreground-800">service@51anime.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-background-100 rounded-xl">
                    <i className="ri-time-line text-xl text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">工作时间</p>
                    <p className="text-sm font-medium text-foreground-800">9:00 - 22:00（每日）</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-background-100 rounded-xl">
                    <i className="ri-wechat-line text-xl text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">官方微信</p>
                    <p className="text-sm font-medium text-foreground-800">51动漫官方</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-background-100 rounded-xl">
                    <i className="ri-map-pin-line text-xl text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">公司地址</p>
                    <p className="text-sm font-medium text-foreground-800">上海市浦东新区张江高科技园区</p>
                  </div>
                </div>
              </div>

              <div className="h-px bg-background-200 mb-6"></div>

              <form
                data-readdy-form="true"
                action="https://readdy.ai/api/form/d9oov6qftmtnfcfh0bh0"
                method="POST"
                encType="application/x-www-form-urlencoded"
                className="space-y-4"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="name" className="block text-xs text-foreground-600 mb-1.5">姓名</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="请输入您的姓名"
                      className="w-full px-4 py-2.5 text-sm border border-background-200 rounded-xl focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all bg-background-50"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-xs text-foreground-600 mb-1.5">邮箱</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="请输入您的邮箱"
                      className="w-full px-4 py-2.5 text-sm border border-background-200 rounded-xl focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all bg-background-50"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="subject" className="block text-xs text-foreground-600 mb-1.5">主题</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    placeholder="请输入主题"
                    className="w-full px-4 py-2.5 text-sm border border-background-200 rounded-xl focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all bg-background-50"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-xs text-foreground-600 mb-1.5">留言内容</label>
                  <textarea
                    id="message"
                    name="message"
                    rows={4}
                    maxLength={500}
                    placeholder="请输入您的留言内容（500字以内）"
                    className="w-full px-4 py-2.5 text-sm border border-background-200 rounded-xl focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all bg-background-50 resize-none"
                  ></textarea>
                </div>
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                <button
                  type="submit"
                  className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm transition-all cursor-pointer whitespace-nowrap"
                >
                  发送留言
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}